// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 35) return "static/js/b95e47fdc2c30e5114eb.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"8182f1bc67a533a08ab2","135":"49569ec79e0b6958fe9b","136":"9e461807084104efb1b0"}[chunkId] + ".chunk.js";
};